import React, { Component } from "react";
import DataContainer from "../containers/DataContainer";
import ApiConfig from "../config/ApiConfig";
import { Button } from "@mui/material";
import AppRoutes from "../config/AppRoutes";
import { getUserId } from "../util/storage/accessTokenStorage";
import mapFetchToProps from "../util/mapFetchToProps";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import Title from "../atoms/typography/Title";
import Subtitle from "../atoms/typography/Subtitle";
import SecondarySubtitle from "../atoms/typography/SecondarySubtitle";
import UswfButton from "../atoms/buttons/UswfButton";
import ChoiceButtons from "../molecules/ChoiceButtons";
import * as PropTypes from "prop-types";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import ILearn from "../molecules/ILearn";

class LookingToDoPage extends Component {
  render() {
    const content = contentMap.LookingToDoPage;
    const navigationsAway = customNavigationMap.LookingToDoPage;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />

            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(LookingToDoPage);
